import classnames from 'classnames';

import { ModalHeader } from './ModalContent';
import { useModals } from './ModalManagerProvider';
import styles from './ModalStack.module.scss';
import { ModalStacked } from './types';

export const MODAL_STACK_ID = 'app-modal-stack';

export const ModalStack = () => {
  const { stack } = useModals();

  return (
    <div className={styles.modalStack} id={MODAL_STACK_ID}>
      {renderStackModals(stack)}
    </div>
  );
};

export function renderStackModals(stack: ModalStacked[], autoRenderFilter = true) {
  return stack
    .filter(({ props: { autoRender = true } }) => autoRender === autoRenderFilter)
    .map((modal, index) => {
      const { animation = 'scale', hasCustomHeader = false, size = 'lg' } = modal.props;
      const zIndex = 1 + index;

      return (
        <div key={index} className={styles.modalContainer} style={{ zIndex }}>
          <div className={styles.backdrop} />

          <div aria-modal="true" className={classnames(styles.modal, styles[animation], styles[size], styles.show)} role="dialog">
            {!hasCustomHeader && <ModalHeader {...modal.props} />}

            <modal.component key={index} open={modal === stack[stack.length - 1]} {...modal.props} />
          </div>
        </div>
      );
    });
}

export function getModalStackElement() {
  return document.getElementById(MODAL_STACK_ID);
}
